import { supabase } from '../supabaseClient';

// Every authorizedFetch path in this app (/fashion-looks/*, /fashion-videos/*, /upload-look)
// belongs to the Fashion Buyer API. It was pointed at REACT_APP_BACKEND2_BASE_URL, which
// is the Virtual Try-On API — a different product with different routes, so every call
// 404'd or failed CORS.
export const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'https://suanfamama-fashion-buyer-production.up.railway.app').replace(/\/$/, '');

export const authorizedFetch = async (url, options = {}) => {
  const { data: { session } } = await supabase.auth.getSession();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (session?.access_token) {
    headers.Authorization = `Bearer ${session.access_token}`;
  }

  // Construct full URL with base URL
  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;

  return fetch(fullUrl, {
    ...options,
    headers,
  });
};
